const API_BASE = 'https://d3bdqxkpn753kf.cloudfront.net';

export const fetchConfig = async (configType) => {
  try {
    const res = await fetch(`${API_BASE}/vrv-config-fetch`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ configType }),
    });
    const data = await res.json();
    const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
    return parsed.data || [];
  } catch (err) {
    console.error('Error fetching config:', err);
    return [];
  }
};

export const fetchAllConfig = async (configType) => {
  try {
    const token = localStorage.getItem('vrvToken');
    const res = await fetch(`${API_BASE}/vrv-config-fetch`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ configType, fetchAll: true }),
    });
    const data = await res.json();
    const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
    return parsed.data || [];
  } catch (err) {
    console.error('Error fetching all config:', err);
    return [];
  }
};

export const manageConfig = async (payload) => {
  try {
    const token = localStorage.getItem('vrvToken');
    const res = await fetch(`${API_BASE}/vrv-config-manage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
    return { statusCode: res.status, ...parsed };
  } catch (err) {
    console.error('Error managing config:', err);
    return { statusCode: 500, message: 'Internal Error' };
  }
};
